import { createApolloClient as coreCreateApolloClient } from '@ts-core/lib/apollo';

export const createApolloClient = () => {
  return coreCreateApolloClient({ uri: '/v2/admin/' });
};
